export const GHG_PER_PRODUCT = {
  PRODUCT_QUANTITY: 'product_quantity',
  PRODUCT_EMISSION: 'product_emission',
  DECLARATION_UNIT_EMISSION: 'declaration_unit_emission',
  ANNUAL_PRODUCT: 'annual_product',
  ANNUAL_PRODUCT_EMISSION: 'annual_product_emission',
  PRODUCT_PRICE: 'product_price',
  ANNUAL_REVENUE: 'annual_revenue',
};
